import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchMtrStructMainDetail(id) {
  const { data: raw } = await request.get(`/mtr-struct-main/${id}`);
  return parseVer4DetailResponse(raw);
}
